// ─── Navbar ───────────────────────────────────────────────
export const nav_home = "Home";
export const nav_accounting = "Accounting Services";
export const nav_taxation = "Taxation Services";
export const nav_mpf = "MPF Services";
export const nav_about = "About Us";
export const nav_contact = "Contact";
export const nav_cta = "Free Consultation";

// ─── Hero ─────────────────────────────────────────────────
export const hero_tag = "Trusted Financial Partner in Hong Kong";
export const hero_h1_1 = "Professional Accounting";
export const hero_h1_2 = "Solutions for Your";
export const hero_h1_3 = "Business Growth";
export const hero_desc = "Nice Accounting provides comprehensive accounting, taxation, and MPF services tailored for businesses and individuals across Hong Kong. Let us handle the numbers — you focus on growth.";
export const hero_cta1 = "Schedule a Consultation";
export const hero_cta2 = "Explore Our Services";
export const hero_scroll = "Scroll";
export const hero_stat1_label = "Years of Experience";
export const hero_stat2_label = "Satisfied Clients";
export const hero_stat3_label = "Client Retention";
export const hero_stat4_label = "Tax Returns Filed";

// ─── About Us ─────────────────────────────────────────────
export const about_tag = "Our Story";
export const about_heading = "About Nice Accounting";
export const about_p1 = "Nice Accounting was founded with a simple mission: to make professional financial services accessible, affordable, and reliable for every business in Hong Kong — from startups to established enterprises.";
export const about_p2 = "Over the years, we have built a reputation for meticulous accuracy, proactive advice, and a genuine commitment to our clients' financial wellbeing. Our team of licensed professionals brings together decades of combined experience across accounting, taxation, and MPF administration.";
export const about_p3 = "We believe that great accounting is more than compliance — it's a strategic advantage. That's why we go beyond the numbers to provide insights that help you make better business decisions.";
export const about_values_heading = "Our Core Values";
export const about_values_sub = "The principles that guide everything we do for our clients.";
export const about_val1_title = "Professional Excellence";
export const about_val1_desc = "Our team consists of certified accountants with deep expertise across accounting, tax, and MPF disciplines.";
export const about_val2_title = "Client-Centric Approach";
export const about_val2_desc = "We treat every client relationship as a long-term partnership, tailoring our services to your unique needs.";
export const about_val3_title = "Confidentiality & Trust";
export const about_val3_desc = "Your financial information is handled with the utmost discretion and protected by strict confidentiality protocols.";
export const about_val4_title = "Proactive Advisory";
export const about_val4_desc = "We don't just crunch numbers — we actively identify opportunities to improve your financial position.";

// ─── Accounting Services ───────────────────────────────────
export const acct_tag = "What We Do";
export const acct_heading = "Accounting Services";
export const acct_desc = "From day-to-day bookkeeping to full financial reporting, our experienced team ensures your accounts are always in perfect order.";
export const acct_s1_title = "Bookkeeping & Accounts";
export const acct_s1_desc = "Accurate and timely bookkeeping to keep your financial records clean, organised, and audit-ready.";
export const acct_s1_i1 = "Monthly / quarterly bookkeeping";
export const acct_s1_i2 = "Bank reconciliation";
export const acct_s1_i3 = "Accounts payable & receivable";
export const acct_s1_i4 = "Financial statement preparation";
export const acct_s2_title = "Financial Reporting";
export const acct_s2_desc = "Clear, comprehensive financial reports that give you a true picture of your business performance.";
export const acct_s2_i1 = "Profit & loss statements";
export const acct_s2_i2 = "Balance sheet preparation";
export const acct_s2_i3 = "Cash flow statements";
export const acct_s2_i4 = "Management accounts";
export const acct_s3_title = "Audit Support";
export const acct_s3_desc = "Professional assistance throughout the audit process to ensure compliance and accuracy.";
export const acct_s3_i1 = "Audit file preparation";
export const acct_s3_i2 = "Liaising with auditors";
export const acct_s3_i3 = "Statutory audit support";
export const acct_s3_i4 = "Internal audit review";
export const acct_s4_title = "Company Secretarial";
export const acct_s4_desc = "Full company secretarial services to keep your business compliant with Hong Kong regulations.";
export const acct_s4_i1 = "Annual return filing";
export const acct_s4_i2 = "Statutory records maintenance";
export const acct_s4_i3 = "Board resolutions";
export const acct_s4_i4 = "Change of directors / shareholders";

// ─── Taxation Services ────────────────────────────────────
export const tax_tag = "Managing Your Tax Obligations";
export const tax_heading = "Taxation Services";
export const tax_desc = "Navigating Hong Kong's tax system with confidence. We handle every aspect of your tax affairs — from preparation and filing to planning and dispute resolution.";
export const tax_s1_title = "Profits Tax";
export const tax_s1_desc = "Accurate preparation and timely filing of corporate profits tax returns to minimise liability and avoid penalties.";
export const tax_s2_title = "Salaries Tax";
export const tax_s2_desc = "Personal income tax filing for individuals, employees, and directors — ensuring compliance with the IRD.";
export const tax_s3_title = "Property Tax";
export const tax_s3_desc = "Expert handling of property tax obligations for landlords and property owners in Hong Kong.";
export const tax_s4_title = "Tax Planning & Advisory";
export const tax_s4_desc = "Strategic tax planning advice to legally minimise your tax exposure and improve cash flow.";
export const tax_s5_title = "Transfer Pricing";
export const tax_s5_desc = "Comprehensive transfer pricing documentation and compliance for multinational businesses.";
export const tax_s6_title = "IRD Enquiries & Objections";
export const tax_s6_desc = "Professional representation and assistance in handling enquiries, objections, and appeals with the IRD.";
export const tax_cta_heading = "Not sure about your tax obligations?";
export const tax_cta_sub = "Get a free 30-minute tax review from our certified professionals.";
export const tax_cta_btn = "Book Free Tax Review";

// ─── MPF Services ─────────────────────────────────────────
export const mpf_tag = "Mandatory Provident Fund";
export const mpf_heading = "MPF Services";
export const mpf_desc = "Ensuring your business meets all Mandatory Provident Fund obligations efficiently and accurately. We take the complexity out of MPF administration so you can focus on running your business.";
export const mpf_step1_title = "MPF Scheme Setup";
export const mpf_step1_desc = "We assist employers in enrolling and setting up the appropriate MPF scheme for their workforce, ensuring full compliance from day one.";
export const mpf_step2_title = "Contribution Management";
export const mpf_step2_desc = "Timely and accurate calculation and arrangement of mandatory and voluntary contributions for both employers and employees.";
export const mpf_step3_title = "Employee Enrolment";
export const mpf_step3_desc = "Handling all paperwork and processes for enrolling new staff and managing changes in employment status.";
export const mpf_step4_title = "Termination & Offset";
export const mpf_step4_desc = "Professional guidance on handling MPF benefits upon contract termination, retirement, and applying the offsetting mechanism (where applicable).";
export const mpf_h1 = "Fully licensed & regulated compliance";
export const mpf_h2 = "Timely contribution submissions";
export const mpf_h3 = "Support for businesses of all sizes";
export const mpf_h4 = "Dedicated MPF consultant assigned";
export const mpf_cta = "Enquire About MPF";

// ─── Contact ──────────────────────────────────────────────
export const contact_tag = "Get In Touch";
export const contact_heading = "Contact Us";
export const contact_desc = "Have a question or ready to get started? Reach out to our team and we'll get back to you within one business day.";
export const contact_d1_label = "Office Address";
export const contact_d1_value = "San Po Kong, Hong Kong";
export const contact_d2_label = "Phone";
export const contact_d2_value = "+852 5680 3868";
export const contact_d3_label = "Email";
export const contact_d3_value = "hello@niceaccountinghk.com";
export const contact_d4_label = "Office Hours";
export const contact_d4_value = "Mon – Fri: 10:00 AM – 5:00 PM";
export const contact_f_name = "Full Name *";
export const contact_f_name_ph = "e.g. Chan Tai Man";
export const contact_f_email = "Email Address *";
export const contact_f_email_ph = "e.g. chan@company.com";
export const contact_f_phone = "Phone Number";
export const contact_f_phone_ph = "e.g. +852 9123 4567";
export const contact_f_service = "Service Interested In";
export const contact_f_service_ph = "Select a service";
export const contact_f_company = "Company Name";
export const contact_f_company_ph = "e.g. ABC Company Limited";
export const contact_f_msg = "Your Message *";
export const contact_f_msg_ph = "Tell us about your requirements...";
export const contact_f_submit = "Send Enquiry";
export const contact_f_sending = "Sending...";
export const contact_f_privacy = "Your information is kept strictly confidential.";
export const contact_success_title = "Message Sent!";
export const contact_success_desc = "Thank you for reaching out. Our team will be in touch with you within one business day.";
export const contact_success_again = "Send Another Message";
export const contact_error = "Something went wrong. Please try again or email us directly.";
export const contact_svc1 = "Accounting Services";
export const contact_svc2 = "Taxation Services";
export const contact_svc3 = "MPF Services";
export const contact_svc4 = "Business Advisory";
export const contact_svc5 = "General Enquiry";

// ─── Footer ───────────────────────────────────────────────
export const footer_desc = "Your trusted accounting partner in Hong Kong. Professional, reliable, and dedicated to your financial success.";
export const footer_phone = "+852 5680 3868";
export const footer_sec1 = "Services";
export const footer_sec2 = "Company";
export const footer_l1_1 = "Accounting Services";
export const footer_l1_2 = "Taxation Services";
export const footer_l1_3 = "MPF Services";
export const footer_l1_4 = "Business Advisory";
export const footer_l2_1 = "About Us";
export const footer_l2_2 = "Our Team";
export const footer_l2_3 = "Our Values";
export const footer_l2_4 = "Contact Us";
export const footer_copy = "Nice Accounting. All rights reserved.";
export const footer_privacy = "Privacy Policy";
export const footer_terms = "Terms of Service";

const common = {
  nav_home, nav_accounting, nav_taxation, nav_mpf, nav_about, nav_contact, nav_cta,
  hero_tag, hero_h1_1, hero_h1_2, hero_h1_3, hero_desc, hero_cta1, hero_cta2, hero_scroll,
  hero_stat1_label, hero_stat2_label, hero_stat3_label, hero_stat4_label,
  about_tag, about_heading, about_p1, about_p2, about_p3, about_values_heading, about_values_sub,
  about_val1_title, about_val1_desc, about_val2_title, about_val2_desc,
  about_val3_title, about_val3_desc, about_val4_title, about_val4_desc,
  acct_tag, acct_heading, acct_desc,
  acct_s1_title, acct_s1_desc, acct_s1_i1, acct_s1_i2, acct_s1_i3, acct_s1_i4,
  acct_s2_title, acct_s2_desc, acct_s2_i1, acct_s2_i2, acct_s2_i3, acct_s2_i4,
  acct_s3_title, acct_s3_desc, acct_s3_i1, acct_s3_i2, acct_s3_i3, acct_s3_i4,
  acct_s4_title, acct_s4_desc, acct_s4_i1, acct_s4_i2, acct_s4_i3, acct_s4_i4,
  tax_tag, tax_heading, tax_desc,
  tax_s1_title, tax_s1_desc, tax_s2_title, tax_s2_desc, tax_s3_title, tax_s3_desc,
  tax_s4_title, tax_s4_desc, tax_s5_title, tax_s5_desc, tax_s6_title, tax_s6_desc,
  tax_cta_heading, tax_cta_sub, tax_cta_btn,
  mpf_tag, mpf_heading, mpf_desc,
  mpf_step1_title, mpf_step1_desc, mpf_step2_title, mpf_step2_desc,
  mpf_step3_title, mpf_step3_desc, mpf_step4_title, mpf_step4_desc,
  mpf_h1, mpf_h2, mpf_h3, mpf_h4, mpf_cta,
  contact_tag, contact_heading, contact_desc,
  contact_d1_label, contact_d1_value, contact_d2_label, contact_d2_value,
  contact_d3_label, contact_d3_value, contact_d4_label, contact_d4_value,
  contact_f_name, contact_f_name_ph, contact_f_email, contact_f_email_ph,
  contact_f_phone, contact_f_phone_ph, contact_f_service, contact_f_service_ph,
  contact_f_company, contact_f_company_ph, contact_f_msg, contact_f_msg_ph,
  contact_f_submit, contact_f_sending, contact_f_privacy,
  contact_success_title, contact_success_desc, contact_success_again, contact_error,
  contact_svc1, contact_svc2, contact_svc3, contact_svc4, contact_svc5,
  footer_desc, footer_phone, footer_sec1, footer_sec2,
  footer_l1_1, footer_l1_2, footer_l1_3, footer_l1_4,
  footer_l2_1, footer_l2_2, footer_l2_3, footer_l2_4,
  footer_copy, footer_privacy, footer_terms,
};

export default common;
